import { BodyText, Heading } from '@utilitywarehouse/hearth-react';

import './styles.scss';

const FeatureListItem = ({
  icon,
  title,
  children,
}: {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}) => (
  <li className="cashback__list-item">
    <div className="cashback__item-icon">{icon}</div>
    <article className="cashback__item-content">
      <Heading size="sm" as="h4">
        {title}
      </Heading>
      <BodyText>{children}</BodyText>
    </article>
  </li>
);

export { FeatureListItem };
